import React from 'react'

export default function PageNotFound() {
  return (
    <div>
      <h2>PageNotFound</h2>
    </div>
  )
}
